'use strict';

var cov_22w9v7iqzx = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/users/usersList/usersList.js',
        hash = '5a37ba1f0d0ad6e26c952f1bbd1c8d71e0e5c692',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/users/usersList/usersList.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 9,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_22w9v7iqzx.s[0]++;
angular.module('app').component('usersList', {
    templateUrl: 'app/components/users/usersList/usersList.html',
    bindings: {
        members: '<',
        accountants: '<'
    }
});